import React from "react";
import { breakPoints } from "~/utils/variables";
import { colors } from "~/utils/colors";

export const InsightDownloadDocs: React.FC = () => {
  return (
    <>
      <style jsx>{`
        .wrapper {
          background: ${colors.gray};
          text-align: center;
          width: 100%;
        }
        .title {
          color: ${colors.defaultText};
          font-size: 3rem;
        }
        .description {
          margin-top: 15px;
          color: ${colors.defaultText};
          font-size: 1.8rem;
        }
        .docs {
          display: flex;
          list-style: none;
        }
        .docsItem {
          width: 300px;
        }
        .docsItem :global(a) {
          display: block;
        }
        @media (${breakPoints.sp}) {
          .wrapper {
            padding: 40px 20px;
            margin: 30px auto 0;
          }
          .docs {
            flex-direction: column;
            margin: 30px auto 0;
            align-items: center;
          }
          .docsItem + .docsItem {
            margin-top: 20px;
          }
        }
        @media (${breakPoints.minPc}) {
          .wrapper {
            padding: 60px 20px;
            margin: 50px auto 0;
          }
          .docs {
            flex-direction: row;
            justify-content: center;
            margin: 50px auto 0;
          }
          .docsItem + .docsItem {
            margin-left: 20px;
          }
        }
      `}</style>
    </>
  );
};
